<template>
  <div class="kk-designer__drop-indicator" :style="{ top: `0px`, left: `${x}px` }">
    <custom-icon class-name="icon-chevron-down kk-designer__drop-indicator-icon" />
  </div>
</template>

<script>
import CustomIcon from "../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  props: ["position", "x", "y"],
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-designer__drop-indicator {
  position: absolute;
  // transition: all 100ms;
  z-index: 260;
  transform: translateX(-50%);
  &-icon {
    font-size: 2rem;
    width: 1rem;
    height: 1rem;
    color: @kk-color-gold;
  }
}
</style>
